import { Component } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Field } from '../../models/field.interface';
import { FieldConfig } from '../../models/field-config.interface';
import { CommonModule } from '@angular/common';
import { RxIconModule } from '@nrwl/rx-icon';
import { MatIconModule } from '@angular/material/icon';
import { MatError } from '@angular/material/form-field';
import { MatButtonModule, MatIconButton } from '@angular/material/button';

@Component({
  selector: 'app-form-password',
  templateUrl: './form-password.component.html',
  styleUrls: ['./form-password.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RxIconModule,
    MatIconModule,
    MatButtonModule,
    MatError,
  ],
})
export class FormPasswordComponent implements Field {
  public config: FieldConfig;
  public group: FormGroup;
  public isPasswordHidden: any = true;

  public get passwordMismatches(): boolean {
    const { valid, dirty } = this.group;
    return this.config.name === 'confirmPassword' && !valid && dirty;
  }

  public togglePasswordVisibility(): void {
    this.isPasswordHidden = !this.isPasswordHidden;
  }
}
